<div class="container row">
  <app-config-line
    [title]="'Preferencias panel de Geopuntos'"
    [titleLevel]="7"
    [withHr]="false"
    [sectionReturn]="configSections.VIEWS_PREFERENCES"
    [render]="!filterOptionsBy"
  >
  </app-config-line>
  
  <app-config-line
    [title]="'Botón para crear geopuntos'"
    [description]="'Muestra u oculta el botón que permite crear nuevos geopuntos en el mapa.'"
    [filterBy]="filterOptionsBy"
    >
    <label class="custom-switch mb-0">
      <input
        type="checkbox"
        [(ngModel)]="geopointService.config.createBtn"
      />
      <span class="slider"></span>
    </label>
  </app-config-line>

  <app-config-line
    [title]="'Contador de geopuntos visibles'"
    [description]="'Muestra la cantidad de geopuntos que están visibles actualmente en el mapa.'"
    [filterBy]="filterOptionsBy"
  >
    <label class="custom-switch mb-0">
      <input
        type="checkbox"
        [(ngModel)]="geopointService.config.showGeopointsVisible"
      />
      <span class="slider"></span>
    </label>
  </app-config-line>

  <app-config-line
    [title]="'Contador de geopuntos ocultos'"
    [description]="'Muestra la cantidad de geopuntos que están ocultos en el mapa.'"
    [filterBy]="filterOptionsBy"
  >
    <label class="custom-switch mb-0">
      <input
        type="checkbox"
        [(ngModel)]="geopointService.config.showGeopointsHidden"
      />
      <span class="slider"></span>
    </label>
  </app-config-line>

  <app-config-line
    [title]="'Columnas personalizables'"
    [description]="'Selecciona qué columnas quieres mostrar en la tabla de geopuntos.'"
    [filterBy]="filterOptionsBy"
  >
    <p-multiSelect
      [options]="columnOptions"
      [(ngModel)]="selectedColumns"
      defaultLabel="Seleccionar columnas"
      [showToggleAll]="false"
      [appendTo]="'body'"
      [selectedItemsLabel]="'{0} columnas seleccionadas'"
      (onChange)="updateVisibleColumns()"
      [maxSelectedLabels]="2"
    ></p-multiSelect>
  </app-config-line>

</div>
